export const serviceOne = `
Design and deploy scalable cloud infrastructure on AWS, GCP, and Azure. 
We help you migrate to the cloud, optimize costs, and ensure high availability.
`;
export const serviceTwo = `
Kubernetes and Docker expertise for container orchestration. We set up and manage 
your containerized applications with Helm, ArgoCD, and best practices.
`;
export const serviceThree = `
Automate your software delivery with GitLab CI, GitHub Actions, and Jenkins. 
We build robust CI/CD pipelines that accelerate your development workflow.
`;
export const serviceFour = `
Infrastructure as Code with Terraform and Ansible. We automate provisioning, 
configuration management, and infrastructure deployment for consistency and reliability.
`;
export const serviceFive = `
Comprehensive monitoring solutions with Prometheus, Grafana, and cloud-native tools. 
Real-time visibility into your infrastructure performance and health.
`;
export const serviceSix = `
Security best practices, compliance, and cloud security implementation. 
We help protect your infrastructure and applications from threats.
`;
